import { defineStore } from "pinia";
import federationsApi, { UserFederation } from "../../Api/federationsApi";
import { handleError } from "../../Common/errorHandler";

export const useFederationStore = defineStore("federation", {
    state() {
        return {
            userId: 0,
            userFederations: [] as UserFederation[],
            isLoaded: false,
            loadingPromise: null as Promise<void> | null,
        };
    },
    getters: {
        isFederationApproved: state => (federationId: string | null | undefined) => {
            if (!federationId) {
                return false;
            }
            const federation = state.userFederations.find(f => f.id === federationId);
            return federation?.approved ?? false;
        },
        singleUnapprovedFederation: state => {
            if (state.userFederations.length === 1 && !state.userFederations[0].approved) {
                return state.userFederations[0];
            }
            return null;
        },
        shouldShowNewOrganizerOnboarding: state => (hasAnyEvents: boolean) => {
            const federations = state.userFederations;
            return federations.length === 1 && !federations[0].approved && !hasAnyEvents;
        },
        isFreshOrganizer: state => {
            const federations = state.userFederations;
            return federations.length === 1 && !federations[0].approved;
        },
    },
    actions: {
        fetchFederationsForUser(forceRefresh = false) {
            // Return cached data if already loaded and not forcing refresh
            if (this.isLoaded && !forceRefresh) {
                return Promise.resolve();
            }

            // Return existing promise if already loading (prevents duplicate calls)
            if (this.loadingPromise) {
                return this.loadingPromise;
            }

            this.loadingPromise = federationsApi
                .getFederationListingForUser()
                .then(federations => {
                    this.userFederations = federations;
                    this.isLoaded = true;
                })
                .catch(handleError)
                .finally(() => {
                    this.loadingPromise = null;
                });

            return this.loadingPromise;
        },
    },
});
